import ActionButton from 'components/ActionButton';
import AddSupplierBlogModal from 'components/AddSupplierBlogModal';
import DeleteActionForTable from 'components/DeleteActionForTableData';
import { tableStyles } from 'css/tableStyles';
import React, { useMemo, useState } from 'react';
import DataTable from 'components/DataTable';
import { removeSupplierBlog } from 'services';
import { showError, showSuccess } from 'utils';
import styles from './index.module.scss';

const SupplierBlogs = props => {
  const [addBlogModalOpen, setAddBlogModalOpen] = useState<boolean>(false);
  const {
    blogs,
    supplierId,
    onSuccess,
  } = props;

  const deleteBlogFn = async (link: string) => {
    try {
      const response = await removeSupplierBlog({
        id: supplierId,
        link,
      });
      onSuccess(response.toJSON());
      showSuccess('Blog deleted successfully');
    } catch (e) {
      showError(e);
    }
  };
  
  const columns = useMemo(() => [
    {
      name: 'Title',
      selector: 'title',
    },
    {
      name: 'Link',
      selector: 'link',
    },
    {
      name: 'Action',
      selector: '',
      sortable: true,
      width: '100px',
      // eslint-disable-next-line react/display-name
      cell: (row: Record<string, any>) => (
        <div className={'ml-3'}>
          <DeleteActionForTable
            onClick={() => deleteBlogFn(row.link)}
          />
        </div>
      ),
    },
  ], [blogs]);
  
  const toggleModal = () => setAddBlogModalOpen(!addBlogModalOpen);
  
  return (
    <div className={styles['blogs-container']}>
      {addBlogModalOpen && (
        <AddSupplierBlogModal
          supplierId={supplierId}
          toggleModal={toggleModal}
          onSuccess={onSuccess}
        />
      )}
      <div className={styles['section-header']}>
        <div className={styles['section-heading']}>Blogs</div>
        <ActionButton
          active={true}
          isLoading={false}
          onClick={toggleModal}
          text={<>Blog <span className={'ml-3'}>+</span></>}
        />
      </div>
      <DataTable
        noHeader
        data={blogs}
        columns={columns}
        customStyles={tableStyles}
      />
    </div>
  );
};

export default SupplierBlogs;